import gql from 'graphql-tag';

export default gql`
	mutation OtpGenerateEmail($email: ID!) {
		otpGenerateEmail(email: $email) {
			ref
		}
	}
`;
